// Hooks
import useOnboardingTasks from '@/utils/hooks/swr/useOnboardingTasks';

// Components
import Loading from '@/components/composite/FirstStats/Loading';
import Content from '@/components/composite/FirstStats/Content';

// Types
import type { StartButtonBlockProps } from '@/components/composite/FirstStats/Content/StartButtonBlock';

type FirstStatsProps = Pick<StartButtonBlockProps, 'start'>;

const FirstStats = ({ start }: FirstStatsProps) => {
    const { isLoading } = useOnboardingTasks({
        shouldRetryOnError: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    });

    if (isLoading) {
        return <Loading />;
    }

    return <Content start={start} />;
};

export default FirstStats;
